import { style } from '@vanilla-extract/css';

export const editProfileButtonContainer = style({
  marginTop: 'auto',
});

export const editProfileButtonContent = style({
  whiteSpace: 'nowrap',
});
